import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { buildWebCreatorPublicUrl } from '../../../api/webCreator';

export default function PublicLinkActions({
  slug,
  published = false,
  size = 'sm',
  className = '',
  showView = true,
}) {
  const [copied, setCopied] = useState(false);

  if (!slug) return null;

  const url = buildWebCreatorPublicUrl(slug);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Copiez le lien :', url);
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      {showView && published ? (
        <a href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
          <Button type="button" size={size} variant="outline" className="h-8">
            <Icon name="ExternalLink" size={14} className="mr-1.5" />
            Voir le lien
          </Button>
        </a>
      ) : null}
      <Button
        type="button"
        size={size}
        variant="outline"
        className="h-8"
        onClick={handleCopy}
        title={published ? 'Copier le lien public' : 'Copier le lien (actif après publication)'}
      >
        <Icon name={copied ? 'Check' : 'Link'} size={14} className="mr-1.5" />
        {copied ? 'Copié !' : 'Copier le lien'}
      </Button>
    </div>
  );
}
